import { z } from "zod";

export const accountStatusEnum = z.enum([
  "ACTIVE",
  "INACTIVE", // has no activities for a long time??
]);

export type accountStatus = z.infer<typeof accountStatusEnum>;
